import { ClipboardList, Fuel, ShieldAlert, Wrench } from "lucide-react";
import { formatIlsCategory } from "../../../domain/rules/aircraft";
import type { FlightCancellation, FlightInstance, GlobalEvent, SaveGame, WorldData } from "../../../domain/types";
import { formatAircraftStatus } from "../../format";
import { EventList } from "../../components/EventList";
import { PanelHeader, StatusLamp } from "../../components/Panel";
import { formatKg } from "./PlayerShared";
import { activeAircraftFlight, nextAircraftFlight } from "./playerData";

export function FleetView({ save }: { save: SaveGame }) {
  return (
    <section className="player-view fleet-layout">
      <section className="panel fleet-main-panel">
        <PanelHeader icon={<Wrench size={15} />} title="机队状态 / 未来可用性" code="FLT" />
        <FleetTable save={save} />
      </section>
    </section>
  );
}

export function LogsView({ save, world, activeEvents, cancellations }: { save: SaveGame; world: WorldData; activeEvents: GlobalEvent[]; cancellations: FlightCancellation[] }) {
  return (
    <section className="player-view logs-layout">
      <section className="panel logs-events-panel">
        <PanelHeader icon={<ShieldAlert size={15} />} title="GM 事件广播" code="EVT" />
        <EventList events={activeEvents} world={world} emptyText="当前没有影响玩家模拟的全局事件。" />
      </section>
      <section className="panel logs-cancel-panel">
        <PanelHeader icon={<ClipboardList size={15} />} title="GM 取消记录" code="CANX" />
        <ul className="message-list">
          {cancellations.slice(0, 20).map((item) => (
            <li key={item.id}>
              D{item.day} {item.occurrenceId} / {item.reason}
            </li>
          ))}
          {cancellations.length === 0 && <li>暂无 GM 航段取消。</li>}
        </ul>
      </section>
      <section className="panel logs-message-panel">
        <PanelHeader icon={<Fuel size={15} />} title="消息 / 运行日志" code="LOG" />
        <ul className="message-list">
          {save.messages.slice(0, 30).map((message, index) => (
            <li key={`${message}-${index}`}>{message}</li>
          ))}
        </ul>
      </section>
    </section>
  );
}

function FleetTable({ save }: { save: SaveGame }) {
  const activeFlights = save.activeOpsDay?.flights ?? [];
  return (
    <div className="table-wrap compact">
      <table>
        <thead>
          <tr>
            <th>飞机</th>
            <th>机型</th>
            <th>位置</th>
            <th>能力</th>
            <th>维修小时</th>
            <th>状态</th>
            <th>当前占用</th>
            <th>下一任务</th>
          </tr>
        </thead>
        <tbody>
          {save.fleet.map((aircraft) => (
            <tr key={aircraft.id}>
              <td>{aircraft.registration}</td>
              <td>{aircraft.typeId.toUpperCase()}</td>
              <td>{aircraft.location}</td>
              <td>ETOPS {aircraft.etopsMinutes} / {Math.round(aircraft.maxTakeoffWeightKg / 1000)}t / FOB {formatKg(aircraft.fuelOnBoardKg)} / {formatIlsCategory(aircraft.ilsCategory)}</td>
              <td>{Math.round(aircraft.hoursSinceMaintenance)}h</td>
              <td>
                <StatusLamp active={aircraft.status === "available"} warn={aircraft.status !== "available"} />
                {formatAircraftStatus(aircraft.status)}
              </td>
              <td>{activeAircraftFlight(save, aircraft.id)?.flightNo ?? "--"}</td>
              <td>{nextAircraftFlight(activeFlights, aircraft.id)?.flightNo ?? "--"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
